import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { BsEye } from 'react-icons/bs';
import Select from '../../components/Select/Select';
import PageHeader from '../../components/PageHeader/PageHeader';
import FilterCard from '../../components/FilterCard/FilterCard';
import Table from '../../components/Table/Table';
import styles from './Akademisyenler.module.css';

const Akademisyenler = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [filters, setFilters] = useState({
    fakulte: [],
    birim: [],
    searchTerm: ''
  });

  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

  const fakulteler = [
    { id: 1, ad: "Mühendislik Fakültesi" },
    { id: 2, ad: "Fen Fakültesi" },
  ];

  const birimler = [
    { id: 1, fakulteId: 1, ad: "Uçak Mühendisliği" },
    { id: 2, fakulteId: 1, ad: "Makine Mühendisliği" },
    { id: 3, fakulteId: 2, ad: "Fizik" },
  ];

  const akademisyenler = [
    {
      id: 1,
      unvan: "Prof. Dr.",
      adSoyad: "Süleyman Türkmen",
      birim: "Uçak Mühendisliği",
      fakulte: "Mühendislik Fakültesi",
      yayinlar: {
        toplam: 4,
        q1: 2,
        q2: 1,
        atifSayisi: 4,
        diger: 1,
        toplamAtif: 120,
        hIndex: 18
      }
    },
  ];

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const birimId = params.get('birim');
    const fakulteAd = params.get('fakulte');
    
    if (fakulteAd) {
      const selectedFakulte = fakulteler.find(f => f.ad === decodeURIComponent(fakulteAd));
      if (selectedFakulte) {
        const fakulteOption = { value: selectedFakulte.id.toString(), label: selectedFakulte.ad };
        setFilters(prev => ({
          ...prev,
          fakulte: [fakulteOption]
        }));

        if (birimId) {
          const selectedBirim = birimler.find(b => 
            b.id === parseInt(birimId) && 
            b.fakulteId === selectedFakulte.id
          );
          if (selectedBirim) {
            const birimOption = { value: selectedBirim.id.toString(), label: selectedBirim.ad };
            setFilters(prev => ({
              ...prev,
              birim: [birimOption]
            }));
          }
        }
      }
    }
  }, [location.search]);

  const handleFilterChange = (field, value) => {
    setFilters(prev => {
      const newFilters = { ...prev, [field]: value };
      
      if (field === 'fakulte') {
        newFilters.birim = [];
      }
      
      return newFilters;
    });
  };

  const filteredBirimler = birimler.filter(birim => 
    !filters.fakulte.length || birim.fakulteId === parseInt(filters.fakulte[0]?.value)
  );

  const filteredAkademisyenler = akademisyenler.filter(akademisyen => {
    const searchMatch = akademisyen.adSoyad.toLowerCase().includes(filters.searchTerm.toLowerCase());
    const fakulteMatch = !filters.fakulte.length || akademisyen.fakulte === fakulteler.find(f => f.id === parseInt(filters.fakulte[0]?.value))?.ad;
    const birimMatch = !filters.birim.length || akademisyen.birim === birimler.find(b => b.id === parseInt(filters.birim[0]?.value))?.ad;
    
    return searchMatch && fakulteMatch && birimMatch;
  });

  const handleAkademisyenDetay = (akademisyenId) => {
    navigate(`/akademisyenler/${akademisyenId}`);
  };

  const handleSort = (key) => {
    setSortConfig(prevConfig => ({
      key,
      direction: prevConfig.key === key && prevConfig.direction === 'asc' ? 'desc' : 'asc'
    }));
  };

  const columns = [
    { key: 'unvan', title: 'Unvan', sortable: true },
    { key: 'adSoyad', title: 'Ad-Soyad', sortable: true },
    { key: 'birim', title: 'Birim', sortable: true },
    { key: 'yayinlar.toplam', title: 'Toplam', sortable: true },
    { key: 'yayinlar.q1', title: 'Q1', sortable: true },
    { key: 'yayinlar.q2', title: 'Q2', sortable: true },
    { key: 'yayinlar.atifSayisi', title: 'Atıf Sayısı', sortable: true },
    { key: 'yayinlar.diger', title: 'Diğer', sortable: true },
    { key: 'yayinlar.toplamAtif', title: 'Toplam Atıf', sortable: true },
    { key: 'yayinlar.hIndex', title: 'H-index', sortable: true },
    {
      key: 'actions',
      title: 'İşlemler',
      render: (_, row) => (
        <button 
          className={styles.actionButton}
          onClick={() => handleAkademisyenDetay(row.id)}
          title="Detay Görüntüle"
        >
          <BsEye />
        </button>
      )
    }
  ];

  const tableData = filteredAkademisyenler.map(akademisyen => ({
    ...akademisyen,
    'yayinlar.toplam': akademisyen.yayinlar.toplam,
    'yayinlar.q1': akademisyen.yayinlar.q1,
    'yayinlar.q2': akademisyen.yayinlar.q2,
    'yayinlar.atifSayisi': akademisyen.yayinlar.atifSayisi,
    'yayinlar.diger': akademisyen.yayinlar.diger,
    'yayinlar.toplamAtif': akademisyen.yayinlar.toplamAtif,
    'yayinlar.hIndex': akademisyen.yayinlar.hIndex
  }));

  const params = new URLSearchParams(location.search);
  const birimAd = params.get('birimAd');
  const fakulteAd = params.get('fakulte');

  const breadcrumbItems = [
    { text: "Ana Sayfa", link: "/" }
  ];

  if (fakulteAd) {
    breadcrumbItems.push({ text: decodeURIComponent(fakulteAd), link: `/fakulte/${fakulteler.find(f => f.ad === decodeURIComponent(fakulteAd))?.id}` });
  }

  if (birimAd) {
    const birim = birimler.find(b => b.ad === decodeURIComponent(birimAd));
    if (birim) {
      breadcrumbItems.push({ text: decodeURIComponent(birimAd), link: `/birim/${birim.id}` });
    }
  }

  breadcrumbItems.push({ text: "Akademisyenler", link: "/akademisyenler" });

  return (
    <div className={styles.wrapper}>
      <PageHeader 
        title="Akademisyenler"
        description="Akademisyen listesi ve yayın performansları"
        breadcrumb={breadcrumbItems}
      />

      <div className={styles.filterSection}>
        <FilterCard>
          <FilterCard.Row>
            <FilterCard.Col>
              <label className={styles.selectLabel}>Fakülte</label>
              <Select
                value={filters.fakulte}
                onChange={(value) => handleFilterChange('fakulte', value)}
                options={fakulteler.map(f => ({
                  value: f.id.toString(),
                  label: f.ad
                }))}
                placeholder="Fakülte seçiniz"
              />
            </FilterCard.Col>
            <FilterCard.Col>
              <label className={styles.selectLabel}>Bölüm/Program</label>
              <Select
                value={filters.birim}
                onChange={(value) => handleFilterChange('birim', value)}
                options={filteredBirimler.map(b => ({
                  value: b.id.toString(),
                  label: b.ad
                }))}
                placeholder="Bölüm/Program seçiniz" 
                disabled={!filters.fakulte.length}
              />
            </FilterCard.Col>
          </FilterCard.Row>
          <FilterCard.Row>
            <FilterCard.Col>
              <FilterCard.Input
                label="Akademisyen Ara"
                type="text"
                placeholder="Ad soyad ile ara..."
                value={filters.searchTerm}
                onChange={(e) => handleFilterChange('searchTerm', e.target.value)}
              />
            </FilterCard.Col>
          </FilterCard.Row>
        </FilterCard>
      </div>
      
      <div className="card no-inner-shadow">
        <div className="card-body">
          <Table
            data={tableData}
            columns={columns}
            onSort={handleSort}
            sortConfig={sortConfig}
          />
        </div>
      </div>
    </div>
  );
};

export default Akademisyenler; 